import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router'
import { Cookies } from 'react-cookie';

import ResponsiveBox, {
    Row,
    Col,
    Item,
    Location,
} from 'devextreme-react/responsive-box';
import Box from 'devextreme-react/box';
import {
    Column,
    DataGrid
} from 'devextreme-react/data-grid';
import RecogResult from "./RecogResult";
import RecogResultSideMenu from "./RecogResultSideMenu";
import config from './Config.js';


function screen(width) {
    return (width < 700) ? 'sm' : 'lg';
}

export default function RecogResultStatusPage() {
    const navigate = useNavigate();
    const cookies = new Cookies();
    const authCheck = () => {
        const aspNetCookie = cookies.get(".AspNetCore.Cookies");
        if (aspNetCookie !== undefined) {
            console.log("Cookie Exists");
        }
        else {
            navigate('/login');
        }
    };

    useEffect(() => {
        authCheck();
    });

    const [getImage, setGetImage] = useState(() => async () => { return null; });
    const [job, setJob] = useState();
    const [recogResultDataList, setRecogResultDataList] = useState();
    const [recogResultData, setRecogResultData] = useState();
    const [isNewCropVersion, setIsNewCropVersion] = useState(false);
    const { jobno } = useParams();

    function RecogResultSelect(rawImageName, idx) {
        getRRData(job.jobNo, rawImageName, idx);
    }
    const getRRData = async (jobno, name, selectedIdx) => {
        let res = await fetch(`${config.apiUrl}/adminpage/detailpage/sum?jobno=${jobno}&rawimagename=${name}`).then(res => res.json());
        res.unshift({
            regNo: -1,
            recogRate: job.recogRate,
            rawImageName: job.rawImageNames[selectedIdx],
            orgImageFileName: job.fullRawImageNames[selectedIdx],
            recogImageFileName: job.fullRawImageNames[selectedIdx]
        });
        const _ = await Promise.all(res.map(async (data, idx) => {
            var url = await getImage(data.orgImageFileName);
            res[idx].orgImg = url;
            url = await getImage(data.recogImageFileName);
            res[idx].recogImg = url;
        })
        );
        let IsNewCropVersion = false;
        res.forEach(data => {
            if (data.imageX != 0) {
                IsNewCropVersion = true;
            }
        });
        if (IsNewCropVersion) {
            let results = []
            await Promise.all(res.map(async (value) => {
                if (value.regNo != -1) {
                    let temp = await fetch(`${config.apiUrl}/adminpage/detailpage/item?regno=${value.regNo}`).then(res => res.json());
                    results.push(...temp);
                }
            }))
            res[1].recogRate = job.recogRate;
            results.sort((a, b) => a.sortNo - b.sortNo);
            res[1].result = results;

            res = [res[0], res[1]];
        }
        setIsNewCropVersion(IsNewCropVersion);
        setRecogResultData(res);
    };

    const setFTP = async () => {
        fetch(`${config.apiUrl}/FTP/connectioninfo`
        ).then(res => res.json()).then(res => {

            const temp = () => async (imgLink) => {
                if (typeof imgLink != "undefined" && imgLink != null) {
                    let url;
                    if (imgLink.startsWith("http"))
                        url = imgLink;
                    else
                        url = `${res.ftP_Host}:${res.ftP_Port}/${imgLink}`

                    return await fetch(url, {
                        crossDomain: true,
                        method: "GET",
                        headers: { 'Authorization': 'Basic ' + btoa(`${res.ftP_ID}:${res.ftP_PW}`) }
                    }).then(res => res.blob()).then(res => {
                        return URL.createObjectURL(res);
                    });
                }
            }

            setGetImage(temp);
        });
    }

    const getJobData = async (jobno) => {
        if (typeof jobno != "undefined" && jobno != null) {
            fetch(`${config.apiUrl}/adminpage/detailpage/job/${jobno}`
            ).then(res => res.json()).then(async res => {
                res.recogRate = `${Math.round(res.recogRate)}%`;
                setJob(res);

                var tempArr = [];
                Promise.all(res.rawImageNames.map(async (name, idx) => {
                    var url = await getImage(name);
                    tempArr.push({
                        idx: idx,
                        name: name,
                        img: url
                    });
                })).then( () => {
                    tempArr.sort(function (a, b) {
                        if(a.hasOwnProperty('idx')) {
                            return a.idx - b.idx;
                        }
                    })
                    setRecogResultDataList(tempArr);
                });
            });
        }
    }

    useEffect(() => {
        setFTP();
    }, []);

    useEffect(() => {
        getJobData(jobno);
    }, [getImage]);

    return(
<div id="page">
    <ResponsiveBox screenByWidth={screen}>
        <Row ratio={1}></Row>
        <Row ratio={9}></Row>

        <Col ratio={1}></Col>
        <Col ratio={9}></Col>
        <Item>
            <Location row={0}
                      col={0}
                      colspan={2}></Location>
            <Box direction="col"
                 width="100%"
                 height="7vh"
                 crossAlign="center">
                <Item ratio={5}>
                    <Box direction="row"
                         width="99vw"
                         height="100%"
                         crossAlign="end">
                        <Item ratio={1}>
                            <DataGrid 
                                dataSource={[job]}
                                style={{
                                    borderWidth: 1,
                                    borderStyle: "solid",
                                    borderColor: "#3cbab2"
                                }}>
                                <Column dataField="jobNo" caption="JOB NO" alignment="center" width={60} />
                                <Column dataField="regDate" caption="해석등록일" alignment="center"/>
                                <Column dataField="compName" caption="고객명" alignment="center"/>
                                <Column dataField="prodName" caption="제품명" alignment="center"/>
                                <Column dataField="firmName" caption="거래처명" alignment="center"/>
                                <Column dataField="siteName" caption="현장명" alignment="center"/>
                                <Column dataField="recogRate" caption="인식률" alignment="center" width={100} />
                                <Column dataField="modifier" caption="변환요청자" alignment="center"/>
                                <Column dataField="modiDay" caption="변환요청일시" alignment="center"/>
                                <Column dataField="modiIP" caption="변환요청IP" alignment="center"/>
                            </DataGrid>
                        </Item>
                    </Box>
                </Item>
            </Box>
        </Item>
        <Item>
            <Location row={1}
                      col={0}></Location>
            <Box direction="col"
                 width="100%"
                 height="92vh"
                 crossAlign="center">
                <Item ratio={1}>
                    <Box width="9vw"
                         height="100%">
                        <Item ratio={1}>
                            <RecogResultSideMenu job={recogResultDataList}
                                                 clickFunction={RecogResultSelect} />
                        </Item>
                    </Box>
                </Item>
            </Box>
        </Item>
        <Item>
            <Location row={1}
                      col={1}>
            </Location>
            <Box width="100%"
                 height="100%">
                <Item ratio={1}>
                    <React.Fragment>
                        <RecogResult data={recogResultData} isNewCropVersion={isNewCropVersion} />
                    </React.Fragment>
                </Item>
            </Box>
        </Item>
    </ResponsiveBox>
</div>
        );
}
